import './display.css'

// The flexible body region of a display window. Scrolls by default; pass `fill`
// for content that manages its own layout (e.g. a PDF viewer) and `padded` for a
// standard 16px inset.
function Display({ children, fill = false, padded = false }) {
  const className =
    'display-body' + (fill ? ' is-fill' : '') + (padded ? ' is-padded' : '')
  return <div className={className}>{children}</div>
}

export default Display
